<div
  class="progress-donut-container"
  [ngStyle]="getCircleStyle()"
  [ngStyle]="getCursorStyle()"
  (click)="onProgressClick()"
>
  <svg
    class="progress-donut-svg"
    [attr.width]="size"
    [attr.height]="size"
    viewBox="0 0 100 100"
  >
    <!-- Définitions des dégradés -->
    <defs>
      <linearGradient id="progressGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style="stop-color: #5cb3f6; stop-opacity: 1" />
        <stop offset="100%" style="stop-color: #1e63b5; stop-opacity: 1" />
      </linearGradient>

      <linearGradient id="backgroundGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style="stop-color: #ffffff; stop-opacity: 1" />
        <stop offset="100%" style="stop-color: #f8f9fa; stop-opacity: 1" />
      </linearGradient>
    </defs>

    <!-- Cercle de fond -->
    <circle
      class="progress-donut-background"
      cx="50"
      cy="50"
      [attr.r]="radius"
      fill="none"
      [ngStyle]="getBackgroundCircleStyle()"
      [attr.stroke]="backgroundColor"
    />

    <!-- Cercle de progression -->
    <circle
      class="progress-donut-progress"
      cx="50"
      cy="50"
      [attr.r]="radius"
      [ngStyle]="getProgressCircleStyle()"
      fill="none"
      stroke="url(#progressGradient)"
      stroke-linecap="butt"
      transform="rotate(-90 50 50)"
    />

    <!-- Disque intérieur blanc pour effet donut -->
    <circle cx="50" cy="50" [attr.r]="radius - (strokeWidth / 2) + 0.5" [attr.fill]="innerFill" />
  </svg>

  <!-- Texte du pourcentage -->
  <div
    *ngIf="showPercentage"
    class="progress-donut-text"
    [ngStyle]="getPercentageStyle()"
  >
    {{ Math.round(progress) }}%
  </div>
</div>
